import { render, staticRenderFns } from "./douyinDetailModal.vue?vue&type=template&id=001ea76e&scoped=true"
import script from "./douyinDetailModal.vue?vue&type=script&lang=js"
export * from "./douyinDetailModal.vue?vue&type=script&lang=js"
import style0 from "./douyinDetailModal.vue?vue&type=style&index=0&id=001ea76e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001ea76e",
  null
  
)

export default component.exports